/* eslint-disable */
/* tslint:disable */

import {
	CommissionAllPropertiesView,
	CommissionEmployeeSimpleResponse,
	CommissionSimpleResponse,
	OrganizationCommissionsIdsResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class Commissions<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Комиссии
	 * @summary Получение существующих комиссий по ID организации
	 * @request GET:/commissions/{org_id}/list
	 * @secure
	 */
	listDetail = (orgId: number, params: RequestParams = {}) =>
		this.request<CommissionSimpleResponse[], void>({
			path: `/commissions/${orgId}/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Комиссии
	 * @summary Получение списка участников и свойств комиссии по её ID
	 * @request GET:/commissions/{comm_id}
	 * @secure
	 */
	commissionsDetail = (commId: number, params: RequestParams = {}) =>
		this.request<CommissionAllPropertiesView, void>({
			path: `/commissions/${commId}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Комиссии
	 * @summary Обновление данных комиссии по ID
	 * @request POST:/commissions/{comm_id}/update
	 * @secure
	 */
	updateCreate = (commId: number, data: CommissionEmployeeSimpleResponse[], params: RequestParams = {}) =>
		this.request<CommissionAllPropertiesView, void>({
			path: `/commissions/${commId}/update`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Комиссии
	 * @summary Создание комиссии по ID ОРГАНИЗАЦИИ
	 * @request POST:/commissions/{org_id}/create
	 * @secure
	 */
	createCreate = (orgId: number, data: CommissionEmployeeSimpleResponse[], params: RequestParams = {}) =>
		this.request<CommissionAllPropertiesView, void>({
			path: `/commissions/${orgId}/create`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Комиссии
	 * @summary Закрытие комиссии по ID
	 * @request POST:/commissions/{comm_id}/close
	 * @secure
	 */
	closeCreate = (commId: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/commissions/${commId}/close`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Комиссии
	 * @summary Получение docx/pdf ссылки документа по его id
	 * @request GET:/commissions/docs/{doc_id}/{format}/link
	 * TODO: не понятно, пишет
	 * @secure
	 */
	docsLinkDetail = (docId: number, format?: string, params: RequestParams = {}) =>
		this.request<string, void>({
			path: `/commissions/docs/${docId}/${format}/link`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Комиссии
	 * @summary Выгрузка утвержденных документов
	 * @request POST:/commissions/docs/{doc_id}/upload
	 * @secure
	 */
	docsUploadCreate = (
		docId: number,
		data: {
			/** @format binary */
			ApprovedDoc?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<CommissionAllPropertiesView, void>({
			path: `/commissions/docs/${docId}/upload`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Комиссии
	 * @summary Получение текущих привязок комиссий к организациям
	 * @request GET:/commissions/orgcoms
	 * @secure
	 */
	orgcomsList = (params: RequestParams = {}) =>
		this.request<OrganizationCommissionsIdsResponse[], void>({
			path: `/commissions/orgcoms`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
}
export const commissionsAPI = new Commissions();
